// extracted by mini-css-extract-plugin
export default {"container":"skills_frameworks_empty_page-module___container___f83c9273","noProfilesIcon":"skills_frameworks_empty_page-module___noProfilesIcon___adc8ca0b"};